import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { palettes, Theme } from '@indigo-ag/component-module';
import React from 'react';

import { createStylesHook, IconButton, IconButtonStatus } from 'shared';
import { Separator } from './Separator';

const useStyles = createStylesHook((theme: Theme) => ({
  containerTooltip: {
    width: 30,
    display: 'flex',
    justifyContent: 'center'
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  padding30x20: {
    padding: '30px 20px'
  },
  sectionTitle: {
    alignSelf: 'center',
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 600
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center'
  },
  sectionSubtitle: {
    alignSelf: 'center',
    marginLeft: '16px',
    color: palettes.brand.red.base
  },
  actionButton: {
    color: palettes.neutral['500'],
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 600,
    marginLeft: 'auto'
  }
}));

export interface PhaseSectionProps {
  title: string;
  subtitle?: string;
  onClickEdit?: () => void;
  open?: boolean;
  children?: React.ReactNode;
  renderSeparatorBefore?: boolean;
  disabled?: boolean;
}

export const PhaseSection: React.FunctionComponent<PhaseSectionProps> = ({
  open,
  children,
  onClickEdit,
  renderSeparatorBefore,
  title,
  subtitle,
  disabled = false
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <>
      {renderSeparatorBefore && <Separator />}
      <div className={classes.padding30x20}>
        <div className={classes.flexContainer}>
          <div className={classes.titleBox}>
            <span className={`${classes.sectionTitle} text-transform-capitalize`}>{title}</span>
            {subtitle && <span className={`${classes.sectionSubtitle} text-transform-capitalize`}>{subtitle}</span>}
          </div>
          {onClickEdit && (
            <div>
              <IconButton
                className={classes.actionButton}
                icon={faEdit}
                onClick={onClickEdit}
                disabled={disabled}
                status={disabled ? IconButtonStatus.DISABLED : IconButtonStatus.ACTIVE}
              />
            </div>
          )}
        </div>
        {open && <div style={{ marginTop: 30 }}>{children}</div>}
      </div>
    </>
  );
};
